import { ReportSdk } from 'lib-klab-sdks';

import {
    ActivityReportMetadata,
    ActivityReportItem,
    ActivityReportPage,
    ActivityReportResponse,
} from '../../../domain/models/reports/activity-report.model';

import {
    AppsTopWithPercentageMetadata,
    AppTopItemWithPercentage,
    AppsTopWithPercentageResponse,
    AppClassification,
} from '../../../domain/models/reports/apps-top-percentage.model';

import { DateRange } from '../../../domain/models/reports/request/app-activity-report.request';

export function mapSdkDateRangeToDomain(dr?: ReportSdk.DateRange): DateRange | undefined {
    if (!dr) return undefined;
    return {
        startDate: dr.startDate,
        endDate: dr.endDate,
    };
}

export function mapSdkActivityMetadataToDomain(
    metadata?: ReportSdk.WebActivityListResponseMetadata,
): ActivityReportMetadata {
    return {
        employeeId: metadata?.employeeId,
        dateRange: mapSdkDateRangeToDomain(metadata?.dateRange),
    };
}

export function mapSdkPaginationToDomain(
    page?: ReportSdk.PaginationResponse,
): ActivityReportPage {
    return {
        page: page?.page ?? 0,
        size: page?.size ?? 0,
        totalElements: page?.totalElements ?? 0,
        totalPages: page?.totalPages ?? 0,
    };
}

export function mapSdkAppActivityItemToDomain(
    item: ReportSdk.AppActivityItem,
): ActivityReportItem {
    return {
        processName: item.processName,
        title: item.title,
        startAt: item.startAt,
        endedAt: item.endedAt,
        activeSeconds: item.activeSeconds,
        idleSeconds: item.idleSeconds,
        totalSeconds: item.totalSeconds,
    };
}

export function mapSdkActivityListResponseToDomain(
    resp: ReportSdk.AppActivityListResponse,
): ActivityReportResponse {
    return {
        metadata: mapSdkActivityMetadataToDomain(resp?.metadata),
        content: (resp?.content ?? []).map(mapSdkAppActivityItemToDomain),
        page: mapSdkPaginationToDomain(resp?.page),
    };
}

export function mapSdkAppsTopMetadataToDomain(
    metadata?: ReportSdk.AppsTopWithPercentageResponseMetadata,
): AppsTopWithPercentageMetadata {
    return {
        employeeId: metadata?.employeeId,
        dateRange: mapSdkDateRangeToDomain(metadata?.dateRange),
        totalSeconds: metadata?.totalSeconds,
    };
}

export function mapSdkAppTopItemToDomain(
    item: ReportSdk.AppTopItemWithPercentage,
): AppTopItemWithPercentage {
    return {
        processName: item.processName,
        totalSeconds: item.totalSeconds,
        classification: (item.classification as AppClassification) || undefined,
    };
}

export function mapSdkAppsTopWithPercentageResponseToDomain(
    resp: ReportSdk.AppsTopWithPercentageResponse,
): AppsTopWithPercentageResponse {
    return {
        metadata: mapSdkAppsTopMetadataToDomain(resp?.metadata),
        content: (resp?.content ?? []).map(mapSdkAppTopItemToDomain),
    };
}